import { CelebrateIcon } from 'assets/icons';
import classNames from 'classnames';
import DualPanel from 'components/foundation/panels/DualPanel/DualPanel';
import { ReactNode } from 'react';
import { ClassName } from 'types/ClassName';
import ConditionalContainer from '../ConditionalContainer/ConditionalContainer';
import './SuccessPage.scss';

export interface ISuccessPageProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  showCelebrateIcon?: boolean;
  className?: ClassName;
}

function SuccessPage({ title, subtitle, children, showCelebrateIcon = true, className }: ISuccessPageProps) {
  function renderLeftContent() {
    return (
      <div className="left-content">
        <ConditionalContainer condition={showCelebrateIcon}>
          <CelebrateIcon className="celebrate-image" />
        </ConditionalContainer>
        <h2>{title}</h2>
        <span className="mt-3">{subtitle}</span>
      </div>
    );
  }

  const classes = classNames('success-page', className);

  return (
    <div className={classes}>
      <DualPanel leftContent={renderLeftContent} rightContent={() => children} />
    </div>
  );
}

export default SuccessPage;
